<template>
    <div>
        <el-select size="small" class="text-value-input" v-model="modelVal" @change="handleChange">
            <el-option v-for="(item,index) in modelListOption" :value="item.Id" :label="item.ModelName" :key="item.Id"></el-option>
            <el-option value="Add New Model" label='' class="add-model-button">Add New Model</el-option>
        </el-select>
        <add-edit-model-dialog v-if="showModelDialog" @onClose="handleCloseAddEditModelDlg"></add-edit-model-dialog>
    </div>

</template>

<script>
    import AddEditModelDialog from "./model/AddEditModelDialog";
    export default {
        name: "ModelSelector",
        components: {AddEditModelDialog},
        data(){
            return {
                modelListOption:[],
                modelVal:this.modelDefault,
                showAddModelDialog:false
            }
        },
        props:{
            modelDefault:{type:String,default:()=>{}}
        },
        watch:{
            modelDefault(val){
                this.modelVal = val;
            }
        },
        model:{
            prop:'modelDefault',
            event:'change'
        },
        methods:{
             async handleChange(val){
                 console.log("handelChange"+ val)
                if(val==="Add New Model"){
                    this.showModelDialog = true
                }else{
                    this.$emit("change",val)
                }

            },
            async getModelList(){
                this.modelListOption = await this.$serverApi.model.modelList()
            },
            addModel(){
                this.$store.commit("setShowAddModelDialog",true)
            },
            handleCloseAddEditModelDlg(){
                this.showModelDialog = false
                this.getModelList()
                this.modelVal = ""
            }
        },
        created(){
            this.getModelList()
        }
    }
</script>

<style scoped lang="stylus">
.add-model-button
    text-align center
    color $color_blue_second
    border-top $color_gray_third 1px  solid
</style>